__turbopack_context__.v({
  "colorifyFill": "dO40QG_colorifyFill",
  "colorifyStroke": "dO40QG_colorifyStroke",
});
